module.exports = __webpack_public_path__ + "3a489f371f7498fbf4df086643397ba0.svg";